import styled from "styled-components";
import NewsAPI from "../../api/NewsAPI";
import { useTranslation } from "react-i18next";
import { NewsPaper } from "../../icons";
import { Article } from "..";
import { useState, useEffect } from "react";

import "./AnnouncementCard.scss";

const Next = styled.a`
  text-decoration: none;
  width: 50%;
  text-align: right;
  color: #f2a900;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;

  &:hover {
    color: #f2a900;
    opacity: 0.8;
  }
`;

const NewsList = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const { data } = (await NewsAPI({ loc: "siaran_pers", page: 1 })).data;
      setNews(data.result.filter((data, i) => i < 3));
    };

    if (news.length === 0) {
      fetchData();
    }
  }, [news]);

  return news.map((data, i) => (
    <div className="list-item" key={i}>
      <Article
        date={data.created_at}
        title={data.title}
        subtitle={data.description}
        slug={data.slug}
        type={"pressconference"}
      />
    </div>
  ));
};

const AnnouncementCard = (props) => {
  const { t } = useTranslation();

  return (
    <div className={`announcement-list ${props.className}`}>
        <div className="header">
          <NewsPaper fill="#85714D" className="icon" />
          <span>{t("press_releases_and_announcements")}</span>
        </div>
        <div className="body">
          <NewsList />
        </div>
      <div className="footer">
        <Next href="/press-conference">{t("more")}</Next>
      </div>
    </div>
  );
};

export default AnnouncementCard;
